import { computed, inject, Signal } from '@angular/core';
import { CaseContextService } from '@app/core/services/case-context/case-context.service';

export const getAppId = (): Signal<number> => {
  const caseContextService = inject(CaseContextService);

  return computed(() => caseContextService.id() || -1);
};
